// extracted by mini-css-extract-plugin
export default {"container":"G1ac839","month":"Gf94181","day":"Ga09e97","dayNumeric":"Gf642c5"};